export const cookies = {
  namespaced: true,
  state: () => ({
    accepted: false
  }),

  mutations: {
    setCookie(state) {
      state.accepted = true
    }
  },

  actions: {
    acceptCookie({ commit }) {
      commit('setCookie')
    }
  }
}
